/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum ActionStatus {
  NOT_STARTED="NOT_STARTED",
PENDING="PENDING",
IN_PROGRESS="IN_PROGRESS",
FINISHED="FINISHED",
FAILED="FAILED",
FINISHED_WITH_FAILED="FINISHED_WITH_FAILED",
STOPPED="STOPPED",
UNDO_REQUESTED="UNDO_REQUESTED",
UNDOING="UNDOING",
UNDONE="UNDONE",
UNDO_FAILED="UNDO_FAILED"
}

/**
* ActionStatus
*/
export const ActionStatusEnumType = types.enumeration("ActionStatus", [
        "NOT_STARTED",
  "PENDING",
  "IN_PROGRESS",
  "FINISHED",
  "FAILED",
  "FINISHED_WITH_FAILED",
  "STOPPED",
  "UNDO_REQUESTED",
  "UNDOING",
  "UNDONE",
  "UNDO_FAILED",
      ])
